var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asta-tavolo" },
    [
      _c("div", { staticClass: "area-logs" }, [
        _c("div", { staticClass: "area-logs-spacer" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "area-logs-center" },
          [
            _vm.astaLogsLast
              ? _c("asta-log", {
                  attrs: { small: "", hasEffect: "", log: _vm.astaLogsLast },
                })
              : _c("div", { staticClass: "area-logs-empty" }, [
                  _vm._v("Registro Eventi"),
                ]),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "btn-logs text-none",
                attrs: { "x-small": "", rounded: "" },
                on: { click: _vm.showAstaLogs },
              },
              [_c("v-icon", [_vm._v("more_horiz")])],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "area-logs-actions" },
          [_c("user-preferences-speed-dial")],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.listoneStatus != 1 && !_vm.listoneStatusClosed
        ? _c(
            "div",
            { staticClass: "px-4 py-1" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "alert-hint",
                  attrs: {
                    dense: "",
                    text: "",
                    color: _vm.listoneStatusColor,
                    icon: "warning",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "alert-hint-close",
                      attrs: { icon: "", "x-small": "" },
                      on: { click: _vm.closelistoneStatus },
                    },
                    [_c("v-icon", { attrs: { small: "" } }, [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n         " + _vm._s(_vm.listoneStatusMsg) + "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAssegnaHint
        ? _c(
            "div",
            { staticClass: "px-4 py-1" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "alert-hint",
                  attrs: {
                    dense: "",
                    text: "",
                    color: "cyan",
                    icon: "touch_app",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "alert-hint-close",
                      attrs: { icon: "", "x-small": "" },
                      on: { click: _vm.dismissAssegnaHint },
                    },
                    [_c("v-icon", { attrs: { small: "" } }, [_vm._v("close")])],
                    1
                  ),
                  _vm._v("\n        " + _vm._s(_vm.assegnaHintText) + "\n    "),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAstaAssegnaInline
        ? _c(
            "div",
            { staticClass: "asta-assegna-inline-wrapper" },
            [_c("asta-assegna")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tavoloLayout == _vm.Constants.TAVOLO_LAYOUT.CERCHIO
        ? _c("asta-tavolo-cerchio")
        : _c("asta-tavolo-griglia"),
      _vm._v(" "),
      _c("div", { staticClass: "top-left-corner" }),
      _vm._v(" "),
      _c("div", { staticClass: "top-right-corner" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }